import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { User } from 'firebase/auth'
import { Center, Spinner } from '@chakra-ui/react'
import useFirestoreUser from '../../hooks/useFirestoreUser'

interface ProfileCompletionGuardProps {
  user: User
}

const ProfileCompletionGuard = ({ user }: ProfileCompletionGuardProps) => {
  const firestoreUser = useFirestoreUser()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Only redirect if we have user data loaded
    if (firestoreUser) {
      const hasCompletedProfile =
        firestoreUser.profile?.agreedToProfileCheckbox === true
      const isOnProfilePage = location.pathname === '/profile'

      // If user hasn't completed profile and they're not on the profile page, redirect them
      if (!hasCompletedProfile && !isOnProfilePage) {
        navigate('/profile', { replace: true })
      }
    }
  }, [firestoreUser, location.pathname, navigate])

  // Show loading spinner while we're waiting for user data
  if (!firestoreUser) {
    return (
      <Center mt='200px'>
        <Spinner size='xl' />
      </Center>
    )
  }

  // Render the child routes
  return <Outlet />
}

export default ProfileCompletionGuard
